/* eslint-disable @typescript-eslint/no-unused-vars */
import { LiveHeaderChips } from "../../components/live/LiveCounters";   // tog'a #3203
import React, { useState, useContext } from "react";
import img from "../../assets/sav-logo-ink.png";   // Tog'a #41: SAV logosi
import {
  Layout,
  Typography,
  Button,
  Space,
  Popconfirm,
  Tooltip,
  message,
} from "antd";
import { TitleContext } from "../../contexts/TitleContext";
import { Search, Settings, Moon, Sun, Monitor } from "react-feather";
import { Download, Trash, Plus, Upload } from "react-feather";
import { getThemeMode, setThemeMode, ThemeMode } from "../../theme/theme";
import { useTranslation } from "react-i18next";
import { Calculator } from "./Calculator";
import Modal from "../../components/modal";
// import { Menu } from "antd";
import SettingsModal from "../../components/modal/settings/SettingsModal";
import { quickFiltersOf, headerSearchOf, headerPinnedOf } from "../../contexts/HeaderExtrasContext"   // s41/s47
import useQueryParams from "../../hooks/useQueryParams";
import { AuthContext } from "../../contexts/auth/AuthContext";
import AddAdminForm from "../../components/form/AddAdminForm";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import "./Header.less";
import UploadExcelModal from "../../components/excel/UploadExcelModal";
import ExportOptionsModal from "../../components/excel/ExportOptionsModal";
import LogoutButton from "../../components/button/LogoutButton";
import LangSwitcher from "../../components/LangSwitcher";
import ThemeToggleButton from "../../components/button/ThemeToggleButton";
import NotificationsBell from "../../components/notifications/NotificationsBell";
import { ScanOutlined } from "@ant-design/icons";
import SubscriptionBattery from "../../components/SubscriptionBattery";   // Boshliq (2026-09-05): foydalanish muddati batareykasi
import ChatBell from "../../components/chat/ChatBell";
import UserChip from "../../components/user/UserChip";
import GlobalHeaderTools from "../../components/layout/GlobalHeaderTools"   // tog'a #3353

// Tog'a #388: telefonda tugmaga bosilganda tooltip ochiq qolib ekrandan chiqardi — sahifa kengligi 417 px ga cho'zilib,
// shu tugma ochgan forma oynasi o'ngga surilib kesilardi. Sichqonchasiz qurilmada sarlavha tooltiplari yo'q.
const tapQurilma = typeof window !== "undefined" && !!window.matchMedia && window.matchMedia("(hover: none)").matches
const Tip: React.FC<React.ComponentProps<typeof Tooltip>> = ({ children, ...rest }) =>
  tapQurilma ? <>{children}</> : <Tooltip {...rest} children={children} />

// Egasi topshirig'i (2026-08-31): DARK MODE tugmasi — light → dark → system
// aylanadi (system = qurilma sozlamasiga ergashish). Tanlov saqlanadi.
// ThemeToggleButton → components/button/ThemeToggleButton (umumiy sarlavhada ham ishlatiladi)
/**
 * Egasi (2026-09-01): «bir yechimning o'zida ideal darajada to'g'ri bo'lsin».
 *
 * Sarlavhadagi tugmalar siqilishi bir necha marta EKRAN KENGLIGI bo'yicha
 * (media query) tuzatilgan edi. U ishlamadi, chunki tugmalar soni SAHIFAGA
 * qarab har xil: «Продажи» da 5 ta, «Товары» da 7 ta. Bitta chegara hammasiga
 * to'g'ri kelmaydi.
 *
 * To'g'ri yechim: ekran kengligini emas, HAQIQIY BO'SH JOYNI o'lchash.
 * Qator sig'masa `hdr-compact` sinfi qo'yiladi — tugmalar yozuvsiz, faqat
 * belgi bo'lib qoladi (izoh Tooltip'da), maydonlar torayadi. Sig'sa — yozuvlar
 * qaytadi. Har sahifada, har kenglikda o'zi to'g'ri qaror qabul qiladi.
 *
 * Sinf qo'yilishi bolalar o'lchamini o'zgartiradi, konteynerning O'ZINIKINI
 * emas — shuning uchun ResizeObserver qayta-qayta uyg'onib ketmaydi.
 */
function useCompactHeader() {
  const ref = React.useRef<HTMLDivElement>(null);
  React.useLayoutEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === "undefined") return;

    const measure = () => {
      // avval to'liq holatda o'lchaymiz (yozuvlar ko'rinib turgan holat)
      el.classList.remove("hdr-compact");

      const header = el.parentElement;
      if (!header) return;
      const hs = window.getComputedStyle(header);
      // sarlavhaning ichki (padding ayirilgan) kengligi
      const avail =
        header.clientWidth -
        (parseFloat(hs.paddingLeft) || 0) -
        (parseFloat(hs.paddingRight) || 0);
      // sahifa nomi ham shu qatorda turadi — u egallagan joyni ayiramiz
      const title = header.querySelector(".TitkeHeader_r") as HTMLElement | null;
      const titleW = title ? title.getBoundingClientRect().width : 0;

      // `scrollWidth` — qatorga KERAK bo'lgan kenglik (to'liq holatda o'lchandi).
      // Faqat `scrollWidth > clientWidth` ni tekshirish YETARLI EMAS edi:
      // qator sarlavhadan tashqariga chiqib ketganda ham ichki toshish
      // bo'lmasligi mumkin — shuning uchun mavjud joy bilan solishtiramiz.
      // Responsiv audit (2026-09-07): qator endi o'raladi (scrollWidth = clientWidth) — ehtiyojni bolalar kengligi yig'indisi bilan o'lchaymiz
      const gap = parseFloat(window.getComputedStyle(el).columnGap) || 6;
      // s39: display:contents o'ramlar (.hdr-filters, .HeaderWrapper_56) kengligi 0 — ichidagi haqiqiy elementlar yig'iladi
      const leafWidth = (node: Element): number => {
        const cs = window.getComputedStyle(node);
        if (cs.display === "contents") return Array.from(node.children).reduce((s, c) => s + leafWidth(c), 0);
        if (cs.display === "none") return 0;
        return node.getBoundingClientRect().width + gap;
      };
      const need = Array.from(el.children).reduce((a, c) => a + leafWidth(c), 0);
      if (need > avail - titleW - 4) el.classList.add("hdr-compact");

      // s262 (2026-09-20, Boshliq test reyestri №3): ixcham rejim HAR DOIM ham yetarli emas.
      // O'lchov (1280px, /products): ixcham holatda ham qatorga 1068px kerak edi, joy esa 904px.
      // Yetmagan qism `margin-left: auto` tufayli CHAPGA oshib, sahifa nomining ustiga chiqardi
      // (chapga toshish `scrollWidth` ga kirmaydi — shuning uchun avvalgi tekshiruvlar buni ko'rmagan).
      // Shuning uchun ixcham holatda QAYTA o'lchaymiz: hali ham sig'masa `hdr-tight` qo'yiladi va
      // ortiqcha qism o'ngga (gorizontal scrollga) oshadi.
      header.classList.remove("hdr-tight");
      if (el.classList.contains("hdr-compact")) {
        const need2 = Array.from(el.children).reduce((a, c) => a + leafWidth(c), 0);
        const titleW2 = title ? title.getBoundingClientRect().width : 0;
        if (need2 > avail - titleW2 - 4) header.classList.add("hdr-tight");
      }
      // sarlavha balandligi (2 qatorga o'ralgan bo'lsa ham) → kontent shuncha pastdan boshlanadi (index.less: margin-top: var(--hdr-h))
      const hh = Math.ceil(header.getBoundingClientRect().height);
      if (hh > 0) document.documentElement.style.setProperty("--hdr-h", hh + "px");
    };

    // O'lchash `scrollWidth` o'qishini talab qiladi (majburiy layout). Sarlavha
    // ichida antd tez-tez DOM o'zgartiradi (bildirishnoma soni, tooltip) —
    // har o'zgarishda o'lchamaslik uchun bitta kadrga yig'amiz.
    let frame = 0;
    const recalc = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        measure();
      });
    };

    measure();
    const ro = new ResizeObserver(recalc);
    ro.observe(el);
    if (el.parentElement) ro.observe(el.parentElement);   // sarlavha balandligi o'zgarsa ham
    // tugmalar to'plami sahifa almashganda o'zgaradi
    const mo = new MutationObserver(recalc);
    mo.observe(el, { childList: true, subtree: true });
    window.addEventListener("resize", recalc);
    return () => {
      if (frame) cancelAnimationFrame(frame);
      ro.disconnect();
      mo.disconnect();
      window.removeEventListener("resize", recalc);
    };
  }, []);
  return ref;
}

export default function Header(props: any) {
  const { title } = useContext(TitleContext);
  const { lg } = useBreakpoint();
  const { authState } = useContext(AuthContext);
  const query = useQueryParams();
  const { t } = useTranslation();
  const headerRowRef = useCompactHeader();
  const leftButtons: JSX.Element[] = [
    <Button
      key="filter"
      size="large"
      className="headermargin_r"
      icon={<Search key="search" />}
      /* Ixcham rejimda yozuv yashiriladi — izoh `title` orqali qoladi.
         DIQQAT: bu tugma Header tomonidan KLONLANADI, shuning uchun uni
         <Tooltip> bilan o'rash mumkin emas (klonlashda yo'qoladi) —
         native `title` esa saqlanadi. */
      title={t("filter")}
      onClick={() => query.set("filtering", "true")}
    >
      {t("filter")}
    </Button>,
  ];

  // Msg 270: 2 tillilik — yorliqlar tarjimadan
  const content = [
    { id: 1, title: t("export") },
    { id: 2, title: t("import") },
    { id: 3, title: t("add") },
    { id: 4, title: t("delete") },
    { id: 5, title: t("settings") },
    { id: 6, title: t("calculator") },
  ];
  const content2 = content.map((a) => (
    <div key={a.id}>
      <p>{a.title}</p>
    </div>
  ));

  return (
    <Layout.Header className="site-layout-header">
      <Typography.Title
        className="TitkeHeader_r"
        style={{ margin: 0 }}
        level={4}
      >
        <img src={img} className="imgHeaderLogo" alt={"img bor edi"} />
        {props.isHasTitle ? t(props.titleName) : title}
      </Typography.Title>
      <div className="HeaderWrapper_r" ref={headerRowRef}>
        {/* s47 (Boshliq): Поиск sarlavhada — Фильтр oynasiga tushmaydi */}
        {headerSearchOf(props.leftButtons).map((x: any, i: number) => (<div className="hdr-search headermargin_r" key={"s" + i}>{x}</div>))}
        {/* tog'a 1764 (2026-09-12): qadalgan tez-filtr (hdr-pin) — sarlavhada, Фильтр oynasidagi nusxasi ham qoladi */}
        {headerPinnedOf(props.leftButtons).map((x: any, i: number) => (<div className="hdr-pin-wrap headermargin_r" key={"p" + i}>{x}</div>))}
        {/* s41: sahifa filtrlari (leftButtons) sarlavhada chizilmaydi — Фильтр oynasi ichida (HeaderExtrasContext); sarlavhada bitta Фильтр */}
        {(props.filterComponent || props.hasFilter || quickFiltersOf(props.leftButtons).length > 0) && (
          <Tip placement="bottom" title={t("filter")}>
            <Button
              size="large"
              className="buttonHeader_r headermargin_r hdr-filter-btn"
              icon={<Search key="search" />}
              onClick={() => query.set(props.filterMatcher || "filtering", "true")}
            >
              {t("filter")}
            </Button>
          </Tip>
        )}
        {props.rightButtons?.map((x: any) => x)}
        {/* {!props.hideCalculator && (
          <>
            <Tip placement="bottom" title={content2[5]}>
              <Button
                size="large"
                className="buttonHeader_r headermargin_r"
                icon={<Calculator />}
                onClick={() =>
                  props.handleActionButtonClick(props.TableActions.EXPORT)
                }
              >
                Калькулятор
              </Button>
            </Tip>
          </>
        )} */}
        {!props.hideExport && (
          <>
            <Tip placement="bottom" title={content2[0]}>
              <Button
                //  title="экспорт"
                size="large"
                className="buttonHeader_r headermargin_r"
                icon={<Download />}
                onClick={() =>
                  props.handleActionButtonClick(props.TableActions.EXPORT)
                }
              >
                {t("export")}
              </Button>
            </Tip>
            {/* </Popover> */}
            <ExportOptionsModal
              onCancel={() => props.setExportModal(false)}
              visible={props.exportModal}
              onOk={props.handleExport}
              loading={
                props.selectedRows.length === 0 ? props.loadingAllData : false
              }
            />
          </>
        )}
        {!props.hideImport && (
          <>
            {/* <Popover placement="bottomLeft" content={content2[1]}> */}
            <Tip placement="bottom" title={content2[1]}>
              <Button
                // data-title="Импорт"
                size="large"
                className="buttonHeader_r headermargin_r"
                icon={<Upload />}
                onClick={() =>
                  props.handleActionButtonClick(props.TableActions.IMPORT)
                }
              >
                {t("import")}
              </Button>
            </Tip>
            {props.sampleData && (
              <UploadExcelModal
                onOk={props.handleImport}
                visible={props.importModal}
                sampleDate={props.sampleData}
                columnsHint={props.importColumnsHint}
                onTemplate={props.importTemplate}
                onCancel={() => props.setImportModal(false)}
              />
            )}
          </>
        )}
        {!props.hideAdd && (
          <>
            <Tip placement="bottom" title={content2[2]}>
              <Button
                size="large"
                // data-title="Добавить"
                className="buttonHeader_r headermargin_r"
                icon={<Plus />}
                onClick={() =>
                  props.handleActionButtonClick(props.TableActions.ADD)
                }
              >
                {t("add")}
              </Button>
            </Tip>
          </>
        )}
        {!props.hideDelete && (
          <>
            <Tip placement="bottom" title={content2[3]}>
              <Popconfirm
                placement="left"
                className="buttonHeader_r headermargin_r"
                title={t("deleteConfirmTitle")}
                okText={t("yes")}
                cancelText={t("no")}
                onConfirm={() =>
                  props.handleActionButtonClick(props.TableActions.DELETE)
                }
                onCancel={() => message.warn(t("canceled"))}
              >
                <Button
                  // data-title="Удалить"
                  size="large"
                  className="buttonHeader_r headermargin_r"
                  loading={props.cLoading}
                  danger={!!props.cError}
                  icon={<Trash />}
                >
                  {t("delete")}
                </Button>
              </Popconfirm>
            </Tip>
          </>
        )}
        {/* Farhod #645: jadval sahifalarida BU sarlavha tepadagi umumiy
            sarlavhani (HeaderHome) to'liq yopib turadi — ikkalasi ham
            `position: fixed; top: 0`. Natijada bildirishnoma qo'ng'irog'i
            (o'qilmaganlar soni bilan) ko'rinmasdi ham, bosilmasdi ham.
            Endi qo'ng'iroq shu yerda ham bor — har sahifada ochiladi. */}
        {/* Responsiv audit (2026-09-07): global blok — drawer ichidagi sahifa sarlavhasida yashiriladi (asosiy sarlavhada bor) */}
        <div className="hdr-global">
        {/* tog'a #3353 (2026-10-04): telefonda faqat 💬 🔔 «⋯», kompyuter va planshetda — avvalgi tartib (components/layout/GlobalHeaderTools).
            s90: skaner — har sahifada; tog'a #3203 (C): bugungi sotuv / zakaz soni. */}
        <GlobalHeaderTools scanner onSettings={() => query.set("settings", "open")} />
        </div>
      </div>
      {/* <div className="HeaderWrapper_r">
        <div className="HeaderWrapper_56" style={{width:"60%"}}>
           {props.filterComponent
          ? [...leftButtons, ...(props.tableProps?.leftButtons || [])]
          : [...(props.tableProps?.leftButtons || [])]}
        </div    
        {!props.hideExport && (
          <>
            <Button
              size="large"
              className="buttonHeader_r"
              icon={<Download color="currentColor" />}
              onClick={() =>
                props.handleActionButtonClick(props.TableActions.EXPORT)
              }
            >
              {lg && t("export")}
            </Button>
            <ExportOptionsModal
              onCancel={() => props.setExportModal(false)}
              visible={props.exportModal}
              onOk={props.handleExport}
            />
          </>
        )}        
        {!props.hideAdd && (
          <Button
            size="large"
            className="buttonHeader_r"
            icon={<Plus color="currentColor" />}
            onClick={() =>
              props.handleActionButtonClick(props.TableActions.ADD)
            }
          >
            {lg && t("add")}
          </Button>
        )}
        {!props.hideDelete && (
          <Popconfirm
            placement="left"
            title={t("deleteConfirmTitle")}
            okText={t("yes")}
            cancelText={t("no")}
            onConfirm={() =>
              props.handleActionButtonClick(props.TableActions.DELETE)
            }
            onCancel={() => message.warn(t("canceled"))}
          >
            <Button
              size="large"
              loading={props.cLoading}
              danger={!!props.cError}
              className="buttonHeader_r"
              icon={<Trash color="currentColor" />}
            >
              {lg && t("delete")}
            </Button>
          </Popconfirm>
        )}
        {!props.hideImport && (
          <>
            <Button
              size="large"
              className="buttonHeader_r"
              icon={<Upload color="currentColor" />}
              onClick={() =>
                props.handleActionButtonClick(props.TableActions.IMPORT)
              }
            >
              {lg && t("import")}
            </Button>
            {props.sampleData && (
              <UploadExcelModal
                onOk={props.handleImport}
                visible={props.importModal}
                sampleDate={proimport { Space } from 'antd';
ps.sampleData}import LogoutButton from './../../components/button/LogoutButton';
import { Settings } from 'react-feather';

                onCancel={() => props.setImportModal(false)}
              />
            )}
          </>
        )}
      </div> */}
      {/* <FactorySelect
        hasEmpty
        key="factory"
        onChange={(val: any) => query.set("factoryId", val.toString())}
        defaultValue={+query.secureGet("factoryId") || ""}
      /> */}
      {/* <Space size={lg ? 20 : 10} className="header-actions">
        {hasPermission(authState.user) && (
          <Button
            onClick={() => query.set("add-admin", "true")}
            type="text"
            shape="circle"
          >
            <UserPlus color="currentColor" />
          </Button>
        )}
        <Button
          className="buttonHeader_r"
          // onClick={() => query.set("settings", "open")}
          type="text"
          shape="circle"
        >
          <Upload color="currentColor" />
          <strong>{t("export")}</strong>
        </Button>
        <Button
          className="buttonHeader_r"
          //  onClick={() => query.set("settings", "open")}
          type="text"
          shape="circle"
        >
          <Download color="currentColor" />
          <strong>{t("import")}</strong>
        </Button>
        <Button
          className="buttonHeader_r"
          //  onClick={() => query.set("settings", "open")}
          type="text"
          shape="circle"
        >
          <Plus color="currentColor" />
          <strong>{t("willAdd")}</strong>
        </Button>
        <Button
          className="buttonHeader_r"
          //  onClick={() => query.set("settings", "open")}
          type="text"
          shape="circle"
        >
          <Trash color="currentColor" />
          <strong>{t("willDelete")}</strong>
        </Button>
        // <Button
        //   className="buttonHeader_r"
        //   onClick={() => query.set("settings", "open")}
        //   type="text"
        //   shape="circle"
        // >
        //   <Settings color="currentColor" />
        // </Button>

        <LogoutButton />
      </Space> */}
      <Modal footer={null} matcher="settings">
        <SettingsModal />
      </Modal>
      <Modal title={t("addAdmin")} footer={null} matcher="add-admin">
        <AddAdminForm />
      </Modal>
    </Layout.Header>
  );
}
